
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Mail, Phone, MapPin } from "lucide-react";

interface ContactInformationCardProps {
  contactEmail: string;
  contactPhone: string;
  contactAddress: string;
  onInputChange: (field: string, value: string) => void;
}

export const ContactInformationCard = ({
  contactEmail,
  contactPhone,
  contactAddress,
  onInputChange,
}: ContactInformationCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Mail className="h-5 w-5 text-brand-purple" />
          Contact Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="contact_email">Email Address</Label>
          <div className="relative">
            <Mail className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
            <Input
              id="contact_email"
              type="email"
              value={contactEmail}
              onChange={(e) => onInputChange("contact_email", e.target.value)}
              className="pl-10"
              placeholder="contact@example.com"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="contact_phone">Phone Number</Label>
          <div className="relative">
            <Phone className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
            <Input
              id="contact_phone"
              value={contactPhone}
              onChange={(e) => onInputChange("contact_phone", e.target.value)}
              className="pl-10"
              placeholder="+1 (555) 123-4567"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="contact_address">Address</Label>
          <div className="relative">
            <MapPin className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
            <Textarea
              id="contact_address"
              value={contactAddress}
              onChange={(e) => onInputChange("contact_address", e.target.value)}
              className="pl-10 min-h-[80px]"
              placeholder="123 Main St, City, Country"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
